import type { CompanyUser, CompanyUserApi, CompanyUsers } from '../../models/company-users.model';

export const normalizeCompanyUser = (u: CompanyUserApi): CompanyUser => ({
  ...u,
  label: `${u.fullName}`,
});

export const normalizeCompanyUsers = (users: CompanyUserApi[]): CompanyUsers => {
  const list = users.sort((a, b) => a.name.localeCompare(b.name)).map(normalizeCompanyUser);
  return {
    list,
    map: list.reduce(
      (acc, customer) => {
        acc[String(customer.id)] = customer;
        return acc;
      },
      {} as CompanyUsers['map'],
    ),
  };
};
